import { hydrate } from 'react-dom';
import VacationFinder from '../shared/vacationFinder/vacationFinder';
import { createVacationFinderStore } from '../shared/utils/createStore';

const initialStateVacationFinder = window.INITIAL_STATE_VACATION_FINDER;

/*
    Allow lazy load of components.
    
    Sets webpack publicPath for files during runtime, since the publicPath is different for each environment.
    //geographical-web.dev.int for dev and //geographical-web.acctest.int for acctest etc.
    Filepaths cannot be relative since the script is run on other domains.
  */
/* eslint-disable no-undef, camelcase */
__webpack_public_path__ = `${initialStateVacationFinder?.siteSettings?.baseUrl}/static/`;

const store = createVacationFinderStore(initialStateVacationFinder);

delete window.INITIAL_STATE_VACATION_FINDER;

const vacationFinderRoot = document.getElementById('vacation-finder-app-root');
if (vacationFinderRoot) {
  hydrate(<VacationFinder store={store} />, vacationFinderRoot);
}
